"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSnakeFromCamel = (string) => string.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
//# sourceMappingURL=get-snake-from-camel.js.map